import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HttpsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"https"}/>
}
